export default __webpack_public_path__ + "static/media/Garage.6808c3e3.png";